import { DatePicker, Form, Input, Select } from 'antd';
import React from 'react';

const { RangePicker } = DatePicker;

export default function ValueForm({
  filters,
  indexParent,
  name,
  extraProps,
  form,
}) {
  const key = Form.useWatch(
    ['filters', indexParent, 'value', name, 'key'],
    form,
  );

  const filter = filters.find((e) => e.key === key);

  if (filter?.valueCPN)
    return React.cloneElement(filter.valueCPN, {
      name: [name, 'value'],
      nameInRoot: ['filters', indexParent, 'value', name, 'value'],
      extraProps,
      item: filter,
      form: form,
    });

  if (filter?.dataSource?.length) {
    return (
      <Form.Item
        {...extraProps}
        name={[name, 'value']}
        rules={[{ required: true, message: 'Missing value' }]}
      >
        <Select
          options={filter?.dataSource}
          className="min-w-180"
          placeholder="Value"
          showSearch={filter?.showSearch}
          optionFilterProp={filter.optionFilterProp}
        />
      </Form.Item>
    );
  }

  if (filter?.isDatePicker) {
    return (
      <>
        <Form.Item
          {...extraProps}
          name={[name, 'value']}
          rules={[{ required: true, message: 'Missing value' }]}
        >
          <RangePicker format="YYYY-MM-DD" />
        </Form.Item>
      </>
    );
  }

  return (
    <Form.Item
      {...extraProps}
      name={[name, 'value']}
      rules={[{ required: true, message: 'Missing value' }]}
    >
      <Input className="min-w-180" />
    </Form.Item>
  );
}
